module.exports = __webpack_public_path__ + "img/icon_01.49bdad57.png";